import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

function MobileLogin() {
  const { tempcode, id } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Validating mobile login...');
  const API_BASE = process.env.REACT_APP_API_URL || 'https://api.insightos.co.uk';

  useEffect(() => {
    const verify = async () => {
      try {
        const { data } = await axios.post(
          `${API_BASE}/api/mobilelogin`,
          { tempcode, id },
          { withCredentials: true }
        );

        if (data?.success && data?.mfaRequired) {
          setStatus('Code verified. Redirecting to MFA...');
          window.location.replace('/mfa');
          return;
        }

        setStatus('Invalid or expired code. Redirecting to login...');
        window.location.replace('/');
      } catch (error) {
        setStatus('Invalid or expired code. Redirecting to login...');
        window.location.replace('/');
      }
    };

    verify();
  }, [tempcode, id, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-indigo-200 via-sky-100 to-white px-4">
      <div className="max-w-md w-full bg-white/80 rounded-2xl shadow-xl p-6 text-center">
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Mobile Login</h1>
        <p className="text-sm text-gray-600">{status}</p>
      </div>
    </div>
  );
}

export default MobileLogin;
